module.exports = global.WebSocket;


//////////////////
// WEBPACK FOOTER
// ./node_modules/roslib/src/util/shim/WebSocket.js
// module id = 157
// module chunks = 0